import React, { useEffect } from "react";
import Chip from "@mui/material/Chip";
import { ShowMoreTooltipData, Tooltip } from "../../index";
import FilterPopover from "../FilterPopover";
import styles from "./filterChips.module.scss";
function isAutocompleteInitialized(filterOption) {
    if (filterOption.freeSolo && !filterOption.onFilterSelect) {
        return true;
    }
    else {
        return filterOption.options !== undefined;
    }
}
function optionsIncludeValues(filter, filterOption) {
    if (filterOption.component !== "autocomplete") {
        return true;
    }
    if (isAutocompleteInitialized(filterOption) && !filterOption.freeSolo) {
        return filter.values.every((value) => { var _a; return (_a = filterOption.options) === null || _a === void 0 ? void 0 : _a.includes(value); });
    }
    else {
        return true;
    }
}
function isFilterDisabled(filter, filterOption) {
    var _a;
    if (!filter || !filterOption) {
        return false;
    }
    if (!optionsIncludeValues(filter, filterOption)) {
        return true;
    }
    else {
        return (_a = filterOption.isChipDisabled) !== null && _a !== void 0 ? _a : false;
    }
}
const chipPrefix = (operator, label) => {
    const isNotOperator = ["is_not", "is_not_any"].includes(operator);
    const isMultipleOperator = ["is_any", "is_not_any"].includes(operator);
    const isTimeOperator = ["before", "after"].includes(operator);
    return [
        isNotOperator ? (React.createElement("strong", { key: "not", className: styles["chip-not-text"] },
            "NOT",
            " ")) : undefined,
        React.createElement("strong", { key: operator }, label),
        isMultipleOperator ? (React.createElement(React.Fragment, { key: "multiple" },
            " ",
            React.createElement("u", null, "is one of"))) : undefined,
        isTimeOperator ? (React.createElement(React.Fragment, { key: "time" },
            " ",
            React.createElement("u", null, operator))) : undefined,
    ];
};
const FiltersChip = ({ name, filter, filterOption, chipRef, onChipClick, onChipDelete, }) => {
    const filterOptionsIncludeValues = optionsIncludeValues(filter, filterOption);
    const isInitialized = filterOption.component === "autocomplete"
        ? isAutocompleteInitialized(filterOption)
        : true;
    useEffect(() => {
        var _a;
        if (!isInitialized && !filterOption.isLoading) {
            (_a = filterOption.onFilterSelect) === null || _a === void 0 ? void 0 : _a.call(filterOption);
        }
    }, [filterOption, isInitialized]);
    if (!isInitialized) {
        return null;
    }
    return (React.createElement(Tooltip, { title: React.createElement(ShowMoreTooltipData, { data: filter.values.map((value) => {
                var _a;
                if (filterOption.component !== "autocomplete") {
                    return value;
                }
                if (filterOption.getChipTooltipText) {
                    return (_a = filterOption.getChipTooltipText(value)) !== null && _a !== void 0 ? _a : value;
                }
                else if (filterOption.getOptionLabel) {
                    const label = filterOption.getOptionLabel(value);
                    return typeof label === "object" ? label.label : label;
                }
                return value;
            }) }), placement: "bottom" },
        React.createElement(Chip, { ref: chipRef, id: `filter-chip-${name}`, key: name, disabled: isFilterDisabled(filter, filterOption), label: [
                chipPrefix(filter.operation, filterOption.label),
                filterOptionsIncludeValues
                    ? `: ${filter.values
                        .map((value) => {
                        var _a, _b;
                        {
                            if (filterOption.component !== "autocomplete") {
                                return value;
                            }
                            if (filterOption.getChipLabel) {
                                return (_a = filterOption.getChipLabel(value)) !== null && _a !== void 0 ? _a : value;
                            }
                            else if (filterOption.getOptionLabel) {
                                return (_b = filterOption.getOptionLabel(value)) !== null && _b !== void 0 ? _b : value;
                            }
                            return value;
                        }
                    })
                        .join(", ")}`
                    : ": <Invalid value>",
            ], onClick: (event) => {
                event.stopPropagation();
                onChipClick();
            }, onDelete: (event) => {
                event.stopPropagation();
                onChipDelete(name);
            }, className: styles["chip-root"], classes: {
                disabled: styles["disabled-chip"],
            } })));
};
const FiltersChips = ({ activeFilters, filterOptions, openChipName, isFilterActive, onChipOpen, onFormClose, onFilterSave, onChipDelete, groupFiltersBy, }) => {
    return (React.createElement(React.Fragment, null, Object.entries(activeFilters)
        .sort(([first], [second]) => {
        const isFirstDisabled = isFilterDisabled(activeFilters[first], filterOptions[first]);
        const isSecondDisabled = isFilterDisabled(activeFilters[second], filterOptions[second]);
        if (isFirstDisabled === isSecondDisabled)
            return 0;
        else if (isFirstDisabled)
            return -1;
        else
            return 1;
    })
        .map(([name, filter]) => (React.createElement(FilterPopover, { key: name, open: openChipName === name, onClose: onFormClose, initialFilterData: { ...filter, name }, filterOptions: filterOptions, onSave: onFilterSave, isFilterActive: isFilterActive, groupFiltersBy: groupFiltersBy, renderTrigger: (ref) => (React.createElement(FiltersChip, { chipRef: ref, name: name, filter: filter, filterOption: filterOptions[name], onChipClick: () => onChipOpen(name), onChipDelete: onChipDelete })) })))));
};
export default FiltersChips;
//# sourceMappingURL=FiltersChips.js.map